export class OrderFrequency {
    ID: number;
    Code: string;
    Name: string;
}

export default OrderFrequency;